<template>
  <div>
    <footer class="page-footer">
      <div class="footer-copyright">
        <div class="flow-text">
          <div class="row">
            <div class="footer-item col l3">©2019 Harrisen Sanchez</div>
            <div id="footer-tags">
              <div class="footer-item col l3">(562)-316-7743</div>
              <div class="footer-item col l3">hmsanchez98@gmail.com</div>
              <div class="footer-item col l3"></div>
              <a
                href="https://drive.google.com/open?id=1GOADqfCuoX2rgT0aqU1gNNjbtm6k6i5S"
                target="_blank"
                class="text-modal"
              >View Resume</a>
            </div>

            <div class="col s4">
              <a class="modal-trigger" id="modal-toggle" href="#modal1">More Info</a>
              <div id="modal1" class="modal">
                <div class="modal-content">
                  <h4>Info</h4>
                  <div class="row">
                    <div class="footer-item col s12">(562)-316-7743</div>
                    <div class="footer-item col s12">hmsanchez98@gmail.com</div>
                    <div class="footer-item col s12"></div>
                    <a
                      href="https://drive.google.com/open?id=1GOADqfCuoX2rgT0aqU1gNNjbtm6k6i5S"
                      target="_blank"
                      class="text-modal"
                    >View Resume</a>
                  </div>
                </div>
                <div class="modal-footer">
                  <a href="#!" class="modal-close waves-effect waves-green btn-flat">Close</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterComp",

  data() {
    return {
      items: [
        { name: "LinkedIn", className: "fab fa-linkedin" },
        { name: "hmsanchez98@gmail.com", className: "fas fa-envelope" },
        { name: "562-316-7743", className: "fas fa-phone" },
        {
          name: "Neumont",
          className: "fas fa-university",
          address: "143 S Main St Salt Lake City, UT 84111"
        }
      ]
    };
  },
    mounted() {
    document.addEventListener("DOMContentLoaded", function() {
      var elems = document.querySelectorAll(".modal");
      var instances = M.Modal.init(elems, {});
    });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page-footer {
  margin-top: 20px;
  position: sticky;
  bottom: 0px;
  width: 100%;
  padding: 0px;
  background-color: rgb(121, 17, 17);
  clear: both;
}
</style>
